// ============================================================================
// salaryProgressionAxis — domaine Y « nice » pour SalaryProgressionChart (F-756)
// ============================================================================
// Graduations regulieres (pas de 10 k$, 25 k$, etc.) englobant toutes les valeurs
// tracees. Algorithme Wilkinson simplifie — fonctions pures, testables.

function niceStep(rawStep: number): number {
  if (!Number.isFinite(rawStep) || rawStep <= 0) return 1;
  const exp = Math.floor(Math.log10(rawStep));
  const base = 10 ** exp;
  const f = rawStep / base;
  if (f <= 1) return base;
  if (f <= 2) return 2 * base;
  if (f <= 5) return 5 * base;
  return 10 * base;
}

export function computeNiceYAxis(
  values: number[],
  targetTickCount = 5,
): { domainMin: number; domainMax: number; ticks: number[] } {
  if (values.length === 0) {
    return { domainMin: 0, domainMax: 1, ticks: [0, 1] };
  }

  const minV = Math.min(...values);
  const maxV = Math.max(...values);

  if (minV === maxV) {
    const pad = Math.max(minV * 0.08, 5_000);
    return computeNiceYAxis([Math.max(0, minV - pad), maxV + pad], targetTickCount);
  }

  const span = maxV - minV;
  const step = niceStep(span / Math.max(1, targetTickCount - 1));
  let domainMin = Math.floor(minV / step) * step;
  let domainMax = Math.ceil(maxV / step) * step;

  if (domainMin > minV) domainMin -= step;
  if (domainMax < maxV) domainMax += step;
  if (domainMin < 0 && minV >= 0) domainMin = 0;

  const ticks: number[] = [];
  for (let v = domainMin; v <= domainMax + step * 0.001; v += step) {
    ticks.push(v);
  }

  return { domainMin, domainMax, ticks };
}
